module.exports = __webpack_public_path__ + "__static/site-1747751661846/img/smile-icon.aad75095.svg";